import { h, Fragment } from "preact";
import AppointmentDetailsList from "../appointments/AppointmentDetailsList";
import CartBlock from "./CartBlock";
import { formatCurrency } from "./cartHelpers";
import useFormStore from "../../store/useFormStore";




export default function CartAccordionMobile({ isShortLeadForm = false }) {
  const cart = useFormStore((state) => state.cart);
  const currentFranchise = useFormStore((state) => state.currentFranchise);
  const usesPricing = currentFranchise?.uses_pricing !== false;

  if (isShortLeadForm) {
    return null;
  }

  // TODO: Need to see what this looks like on mobile without pricing
  return (
    <div className="cart-accordion-mobile">
      <details className="group border-b border-b-[#ccc] bg-coit-yellow p-4">
        <summary className="flex items-center justify-between cursor-pointer list-none text-gray-900 focus:outline-0 border-0 mb-0">
          <div className="flex flex-col gap-1">
            {usesPricing ? (
              <span className="text-lg font-semibold">Estimated Total: {formatCurrency(cart.total)}</span>
            ) : (
              <span className="text-lg font-semibold">Requested Services</span>
            )}
          </div>
          <svg
            className="w-5 h-5 transition-transform group-open:rotate-180"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </summary>
        <div className="mt-4 flex gap-3 flex-col">
          <AppointmentDetailsList />
          <CartBlock title={usesPricing ? "Your Estimate" : "Requested Services"} />
        </div>
      </details>
    </div>
  );
}
